module.exports = __webpack_public_path__ + "static/media/ritratto.e1a482f7.jpg";